<template>
  <div class="release_manager_container">
    <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8" />

    <div class="container-fluid mt--7 ">

      <div class="row">
        <div class="col">
          <div class="card mb-3">

            <div class="col-md-12 cont">
              <div class="header_nav">
                <h2 style="margin: 20px 0;">Release Manager</h2>
                <button class="btn btn-success btn-sm" @click="operateDrawer('create')" v-if="!showDrawer">+ Add New
                  Release</button>
                <!-- <button class="btn btn-danger btn-sm" @click="operateDrawer('cancel')" v-if="showDrawer">
                  Cancel</button> -->
              </div>

              <a-table :columns="columns" :data-source="tableData" :pagination="pagination" @change="handleTableChange"
                :loading="loading" :rowKey="(record) => record.id" class="ant-table-striped" bordered size="small">
                <template slot="action" slot-scope="record">
                  <center>
                    <a-button class="btn btn-success btn-sm" slot="action"
                      @click="showRecord(record, 'view')">View</a-button>
                    <a-button class="btn btn-warning btn-sm" slot="action"
                      @click="showRecord(record, 'edit')">Edit</a-button>
                    <a-popconfirm slot="action" title="Are you sure you want to delete this record ?"
                      @confirm="deleteRecord(record)">
                      <a-button class="btn btn-danger btn-sm">Delete</a-button>
                    </a-popconfirm>
                  </center>
                </template>
              </a-table>

              <a-spin :spinning="spinning">
                <a-drawer title="" width="600" placement="right" @close="operateDrawer('cancel')" :visible="showDrawer">
                  <a-form class="form_container">

                    <div class="combined_layout">
                      <a-form-item label="Version:" class="version">
                        <a-input placeholder="ex: 1.0.0" v-model="version" :disabled="isViewing" />
                      </a-form-item>

                      <a-form-item name="modules" label="Modules" class="form_input" allowClear>
                        <a-select placeholder="Select Modules" mode="multiple" v-model="modules" :disabled="isViewing">
                          <a-select-option value="MMS">MMS</a-select-option>
                          <a-select-option value="POS">POS</a-select-option>
                          <a-select-option value="WAVELETS">WAVELETS</a-select-option>
                        </a-select>
                      </a-form-item>

                      <a-form-item name="date-picker" label="Deployed At: " class="form_input">
                        <a-date-picker value-format="YYYY-MM-DD" v-model="release_date" :disabled="isViewing" />
                      </a-form-item>

                      <a-form-item name="sprint" label="Sprint #: " class="form_input">
                        <a-input-number style="width: 100%;" v-model="sprint" :disabled="isViewing" />
                      </a-form-item>

                      <a-form-item name="status" label="Status" class="form_input" v-model="status">
                        <a-select placeholder="Select Status" v-model="status" :disabled="isViewing">
                          <a-select-option value="Deployed">Deployed</a-select-option>
                          <a-select-option value="Ongoing">Ongoing</a-select-option>
                        </a-select>
                      </a-form-item>
                    </div>

                    <a-form-item class="description" name="description" label="Details and Description">
                      <quill-editor ref="myQuillEditor" style="height: 200px;" v-model="description"
                        :disabled="isViewing" />
                    </a-form-item>

                    <a-form-item class="form_footer" v-if="!isViewing">
                      <!-- <a-button style="margin-right: 10px" class="btn-danger"> Cancel </a-button> -->
                      <a-button style="margin-right: 10px" class="btn-success" @click="processRequest('save')"> Save
                      </a-button>
                      <a-button type="primary" @click="processRequest('publish')"> Publish </a-button>
                    </a-form-item>
                  </a-form>
                </a-drawer>
              </a-spin>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
import { mapState } from 'vuex'
import axios from 'axios';
import secureStorage from '../../controllers/secureStorage';
// import ValidateField from '../../components/validateFormUtils';

export default {
  mounted: async function () {
    this.loading = true
    this.getTableData()
  },
  computed: {
    ...mapState(['endPoint', 'profileId', "parameters"]),
  },
  data: function () {
    return {
      columns: [
        {
          title: 'Version',
          dataIndex: 'version'
        },
        {
          title: 'Status',
          dataIndex: 'status'
        },
        {
          title: 'Published',
          dataIndex: 'is_published'
        },
        {
          title: 'Release Date',
          dataIndex: 'release_date'
        },
        {
          title: 'Sprint #',
          dataIndex: 'sprint'
        },
        {
          title: 'Action',
          dataIndex: 'id',
          scopedSlots: { customRender: 'action' }
        }
      ],
      tableData: [],
      showDrawer: false,
      selectedReleaseId: null,
      version: null,
      modules: [],
      status: null,
      release_date: null,
      sprint: null,
      status: null,
      description: null,
      is_published: false,
      spinning: false,
      default_display: 5,
      currentPage: 1,
      pagination: {
        pageSize: 5,
      },
      loading: false,
      isEditing: false,
      isViewing: false,
    }
  },
  methods: {
    checkErrors() {

      let errors = [];

      if ( this.version === null || this.version.length === 0) {
        errors.push('Version cannot be empty')
      }
      if ( this.modules.length === 0 ) {
        errors.push('Modules cannot be empty')
      }
      if ( this.status === null ) {
        errors.push('Status cannot be empty')
      }
      if ( this.release_date === null ) {
        errors.push('Release Date cannot be empty')
      }
      if ( this.sprint === null) {
        errors.push('Sprint cannot be empty')
      }
      if ( this.status === null ) {
        errors.push('Status cannot be empty')
      }
      if (this.description.join('').length === 0) {
        errors.push('Description cannot be empty')
      }


      if (errors.length > 0) {
        // Prompt error if there's an error
        errors.forEach((error) => {
          this.$notification['error']({
            message: 'Error',
            description: error,
          });
        })
        return true;
      }
      return false;
    },
    async getTableData() {
      await HTTPRequest.getRequest(`${this.endPoint}releases?per_page=${this.default_display}&is_admin=true`)
        .then((resp) => {
          var pagination = { ...this.pagination };
          pagination.total = resp.total;
          pagination.pageSize = Number(this.default_display);
          this.pagination = pagination
          this.tableData = resp.data.map((item) => {
            // item.release_date = new Date(item.release_date).toLocaleDateString()
            item.is_published = item.is_published === true ? 'YES' : 'NO'
            item.modules = JSON.parse(item.modules)
            item.description = JSON.parse(item.description)
            return item
          })
          this.loading = false
        })
    },
    async handleTableChange(pagination) {
      this.loading = true
      var pager = { ...this.pagination };
      pager.current = pagination.current;
      this.currentPage = pagination.current;
      pager.pageSize = Number(this.default_display);
      this.pagination = pager;
      await HTTPRequest.getRequest(`${this.endPoint}releases?per_page=${this.default_display}&page=${pagination.current}&is_admin=true`)
        .then((resp) => {
          var pagination = { ...this.pagination };
          pagination.total = resp.total;
          pagination.pageSize = Number(this.default_display);
          this.pagination = pagination
          this.tableData = resp.data.map((item) => {
            item.is_published = item.is_published === true ? 'YES' : 'NO'
            // item.release_date = new Date(item.release_date).toLocaleDateString()
            item.modules = JSON.parse(item.modules)
            item.description = JSON.parse(item.description)
            return item
          })
        })
      this.loading = false;
    },
    showRecord(id, action) {
      this.showDrawer = true
      this.selectedReleaseId = id
      let result = this.tableData.filter((record) => record.id === id)[0]

      if (action === 'edit') {
        this.isEditing = true
      } else {
        this.isViewing = true
      }
      this.operateDrawer(action, result)

    },
    async deleteRecord(id) {

      await axios({
        method: 'delete',
        url: `${this.endPoint}/releases/${id}`,
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
        },
        // data: sitePayload
      }).then(({ data: { status, message } }) => {
        if (status === 200) {
          this.$notification['success']({
            message: 'Success',
            description: message,
          });
        }

      })
      // this.spinning = false
      // this.spinning = false
      this.operateDrawer('cancel')
      this.handleTableChange({ ...this.pagination, current: this.currentPage })
    },
    operateDrawer(action, params) {
      if (action === 'create') {
        action == 'create' ? this.showDrawer = true : this.showDrawer = false;
      } else if (action === 'edit' || action === 'view') {
        this.version = params.version
        this.modules = params.modules
        this.status = params.status
        this.release_date = params.release_date
        this.sprint = params.sprint
        this.status = params.status
        this.description = params.description.join("\n")
        this.$refs.myQuillEditor.quill.setText(this.description)
        this.$refs.myQuillEditor.quill.formatLine(0, this.description.length, 'list', 'bullet');
        // this.is_published = params.is_published
      } else {
        this.showDrawer = false
        this.clearFormData()
      }
    },
    clearFormData() {
      this.version = null
      this.modules = []
      this.status = null
      this.release_date = null
      this.status = null
      this.sprint = null
      this.description = null
      this.is_published = false
      this.isEditing = false
      this.isViewing = false
      this.selectedReleaseId = null
    },
    async processRequest(action) {
      this.spinning = true
      // this.description = this.$refs.myQuillEditor.quill.container.innerText.split('\n')
      this.description = this.$refs.myQuillEditor.quill.container.innerText.split('\n').filter((str) => str != '')
      this.is_published = action === 'publish' && true
      const hasErrors = this.checkErrors();

      if (hasErrors) {
        this.spinning = false
        return
      } else {
        let payLoad = {
          version: this.version,
          status: this.status,
          release_date: this.release_date,
          sprint: this.sprint,
          modules: JSON.stringify(this.modules),
          status: this.status,
          description: JSON.stringify(this.description),
          is_published: this.is_published
        }
        await axios({
          method: this.isEditing ? 'put' : 'post',
          url: `${this.endPoint}releases/${this.selectedReleaseId === null ? '' : this.selectedReleaseId}`,
          headers: {
            Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
          },
          data: payLoad
        }).then(({ data: { status, message } }) => {
          if (status === 200) {
            this.$notification['success']({
              message: 'Successfully',
              description: message,
            });
          }

        })
        this.spinning = false
        this.operateDrawer('cancel')
        this.handleTableChange({...this.pagination, current:this.currentPage})
      }
    }
  }
}
</script>

<style scoped>
.header_nav {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.form_container {
  display: flex;
  flex-direction: column;
}

.combined_layout {
  display: grid;
  column-gap: 10px;
  /* grid-area: left-side; */
  grid-template-columns: 1fr 1fr 1fr;
  /* grid-template-rows: 1fr 1fr; */
  width: 100%;
}

.version {
  column-span: 2;
}

.form_footer {
  position: absolute;
  bottom: 0;
  right: 25px;
}</style>